// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GarminMapLegend_legendButton__y4Srf {
    position: relative;
    z-index: 10001;
    background-color: white;
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 2px solid var(--color-lightui-accent-2);
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    /*box-shadow: 0 0 2px var(--color-103);*/
}

.GarminMapLegend_legendIcon__bBJPZ {
    background-image: url("data:image/svg+xml,%3Csvg width='8' height='18' viewBox='0 0 8 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.3959 5.67938C5.61759 5.67938 5.80217 5.76378 5.94965 5.93167C6.09713 6.10048 6.17133 6.33701 6.17133 6.64032C6.17133 7.22375 5.9042 8.42307 5.37086 10.2383L4.96645 11.5684C4.35148 13.622 4.04446 14.9196 4.04446 15.4622C4.04446 15.7414 4.15855 15.8806 4.38858 15.8806C4.60099 15.8806 5.30315 15.4863 6.49412 14.6979L6.82711 15.3509L4.27728 17.0511C3.59739 17.4787 3.08538 17.7496 2.74126 17.8646C2.50288 17.9545 2.2812 18 2.07621 18C1.76362 18 1.52339 17.8952 1.3555 17.6856C1.18669 17.4769 1.10321 17.1374 1.10321 16.6699C1.10321 16.0531 1.23399 15.2647 1.49742 14.3037L2.32293 11.3717C2.73755 9.90158 2.94532 8.94435 2.94532 8.50098C2.94532 8.28764 2.85071 8.18097 2.66242 8.18097C2.53071 8.18097 2.33314 8.24683 2.07064 8.37761C1.42971 8.70597 0.859264 9.05936 0.358388 9.43688L0.0625 8.77182C2.05024 7.3267 3.31077 6.46779 3.84411 6.19695C4.53328 5.8519 5.05085 5.67938 5.3959 5.67938ZM6.04148 0C6.44218 0 6.76682 0.125219 7.01633 0.375657C7.26584 0.626095 7.39106 0.956302 7.39106 1.36721C7.39106 1.94229 7.22966 2.41441 6.90595 2.7845C6.58316 3.15366 6.16762 3.33825 5.66118 3.33825C5.25213 3.33825 4.92193 3.21303 4.67241 2.96259C4.4229 2.71215 4.29861 2.39771 4.29861 2.0202C4.29861 1.39596 4.46186 0.903432 4.78929 0.541688C5.11671 0.179944 5.53411 0 6.04148 0Z' fill='%23252525'/%3E%3C/svg%3E");
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    display: inline-block;
}

.GarminMapLegend_legendModal__yLBom {
    display: none;
    position: absolute;
    width: 378px;
    min-height: 100px;
    left: -420px;
    border-radius: 4px;
    background-color: white;
    padding: 16px;
    box-shadow: 0 0 2px var(--color-103);
}

.GarminMapLegend_legendModal__yLBom.GarminMapLegend_closed__XU69f {
    display: none;
}

/*same as controlDialogOpen from MapProviderContainer*/
.GarminMapLegend_legendModal__yLBom.GarminMapLegend_open__eTvIF {
    display: inline-block;
    border-radius: 4px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 39px;
    right: 58px;
    left: auto;
    background-color: white;
    margin-top: -30px;
    margin-left: -370px;
    z-index: 20000;
    padding: 16px;
}

.GarminMapLegend_header__Annkk {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.GarminMapLegend_title__HgClq {
    font-size: 16px;
    font-weight: 300;
    text-transform: capitalize;
}

.GarminMapLegend_closeLegend__vJSKY {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.9999 1.11662L15.8533 0L8.78612 6.8839L1.71782 0L0.571289 1.11662L7.63958 8.00053L0.571289 14.8844L1.71782 16L8.78612 9.1161L15.8533 16L16.9999 14.8844L9.93157 8.00053L16.9999 1.11662Z' fill='%236C6C6C'/%3E%3C/svg%3E");
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
}

.GarminMapLegend_legendContent__zCuz7 {
    padding-top: 20px;
}

.GarminMapLegend_dialogBackdrop__vdYGg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    background-color: var(--color-106);
    opacity: .8;
}

/*
    Mobile views
*/

@media only screen and (max-width: 47.9375em) {
    .GarminMapLegend_legendModal__yLBom {
        width: 270px;
        max-width: 67%;
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/components/GarminMapLegend.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,g7CAAg7C;IACh7C,0BAA0B;IAC1B,kCAAkC;IAClC,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA,sDAAsD;AACtD;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,6ZAA6Z;IAC7Z,0BAA0B;IAC1B,kCAAkC;IAClC,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,cAAc;IACd,kCAAkC;IAClC,WAAW;AACf;;AAEA;;CAEC;;AAED;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ","sourcesContent":[".legendButton {\n    position: relative;\n    z-index: 10001;\n    background-color: white;\n    display: inline-block;\n    width: 30px;\n    height: 30px;\n    border: 2px solid var(--color-lightui-accent-2);\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: center;\n    /*box-shadow: 0 0 2px var(--color-103);*/\n}\n\n.legendIcon {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='18' viewBox='0 0 8 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.3959 5.67938C5.61759 5.67938 5.80217 5.76378 5.94965 5.93167C6.09713 6.10048 6.17133 6.33701 6.17133 6.64032C6.17133 7.22375 5.9042 8.42307 5.37086 10.2383L4.96645 11.5684C4.35148 13.622 4.04446 14.9196 4.04446 15.4622C4.04446 15.7414 4.15855 15.8806 4.38858 15.8806C4.60099 15.8806 5.30315 15.4863 6.49412 14.6979L6.82711 15.3509L4.27728 17.0511C3.59739 17.4787 3.08538 17.7496 2.74126 17.8646C2.50288 17.9545 2.2812 18 2.07621 18C1.76362 18 1.52339 17.8952 1.3555 17.6856C1.18669 17.4769 1.10321 17.1374 1.10321 16.6699C1.10321 16.0531 1.23399 15.2647 1.49742 14.3037L2.32293 11.3717C2.73755 9.90158 2.94532 8.94435 2.94532 8.50098C2.94532 8.28764 2.85071 8.18097 2.66242 8.18097C2.53071 8.18097 2.33314 8.24683 2.07064 8.37761C1.42971 8.70597 0.859264 9.05936 0.358388 9.43688L0.0625 8.77182C2.05024 7.3267 3.31077 6.46779 3.84411 6.19695C4.53328 5.8519 5.05085 5.67938 5.3959 5.67938ZM6.04148 0C6.44218 0 6.76682 0.125219 7.01633 0.375657C7.26584 0.626095 7.39106 0.956302 7.39106 1.36721C7.39106 1.94229 7.22966 2.41441 6.90595 2.7845C6.58316 3.15366 6.16762 3.33825 5.66118 3.33825C5.25213 3.33825 4.92193 3.21303 4.67241 2.96259C4.4229 2.71215 4.29861 2.39771 4.29861 2.0202C4.29861 1.39596 4.46186 0.903432 4.78929 0.541688C5.11671 0.179944 5.53411 0 6.04148 0Z' fill='%23252525'/%3E%3C/svg%3E\");\n    background-size: 14px 14px;\n    background-position: center center;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n}\n\n.legendModal {\n    display: none;\n    position: absolute;\n    width: 378px;\n    min-height: 100px;\n    left: -420px;\n    border-radius: 4px;\n    background-color: white;\n    padding: 16px;\n    box-shadow: 0 0 2px var(--color-103);\n}\n\n.legendModal.closed {\n    display: none;\n}\n\n/*same as controlDialogOpen from MapProviderContainer*/\n.legendModal.open {\n    display: inline-block;\n    border-radius: 4px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    top: 39px;\n    right: 58px;\n    left: auto;\n    background-color: white;\n    margin-top: -30px;\n    margin-left: -370px;\n    z-index: 20000;\n    padding: 16px;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.title {\n    font-size: 16px;\n    font-weight: 300;\n    text-transform: capitalize;\n}\n\n.closeLegend {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.9999 1.11662L15.8533 0L8.78612 6.8839L1.71782 0L0.571289 1.11662L7.63958 8.00053L0.571289 14.8844L1.71782 16L8.78612 9.1161L15.8533 16L16.9999 14.8844L9.93157 8.00053L16.9999 1.11662Z' fill='%236C6C6C'/%3E%3C/svg%3E\");\n    background-size: 14px 14px;\n    background-position: center center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n}\n\n.legendContent {\n    padding-top: 20px;\n}\n\n.dialogBackdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 10000;\n    background-color: var(--color-106);\n    opacity: .8;\n}\n\n/*\n    Mobile views\n*/\n\n@media only screen and (max-width: 47.9375em) {\n    .legendModal {\n        width: 270px;\n        max-width: 67%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendButton": `GarminMapLegend_legendButton__y4Srf`,
	"legendIcon": `GarminMapLegend_legendIcon__bBJPZ`,
	"legendModal": `GarminMapLegend_legendModal__yLBom`,
	"closed": `GarminMapLegend_closed__XU69f`,
	"open": `GarminMapLegend_open__eTvIF`,
	"header": `GarminMapLegend_header__Annkk`,
	"title": `GarminMapLegend_title__HgClq`,
	"closeLegend": `GarminMapLegend_closeLegend__vJSKY`,
	"legendContent": `GarminMapLegend_legendContent__zCuz7`,
	"dialogBackdrop": `GarminMapLegend_dialogBackdrop__vdYGg`
};
export default ___CSS_LOADER_EXPORT___;
